import React from 'react';
import { Typography } from '@mui/material';
import StyledTable from '../../../atoms/StyledTable/StyledTable';
import backInTimeInfo from './constants';

const headers = [
  'Category',
  'Game Scores',
  'Player & Team Game Stats',
  'Notes',
];

const rowMap = {
  'Category': 'categoryName',
  'Game Scores': 'gameScores',
  'Player & Team Game Stats': 'playerAndTeamStats',
  'Notes': 'notes',
}

export default function NcaaMbbGameDataInfoModal() {
  return (
    <>
      <StyledTable
        uniqueRowKey='No'
        headers={headers}
        data={backInTimeInfo}
        dataMap={rowMap}
      />
      <Typography sx={{ mt: 2, fontSize: '14px', fontStyle: 'italic' }}>
        * = Complete Tournament History
      </Typography>
    </>
  );
};
